import { CellarDesignBase } from './base/cellar-design-base';

export class CellarDesign extends CellarDesignBase { }